import { Component, OnInit } from '@angular/core';
import { ClaimService } from '@services/claim/claim.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
    WorklistModuleRequest,
    WorklistSummaryResponse,
} from '@core/generated/openapi';
import { NotificationServiceUP } from '@services/notifications/notification-service-u-p.service';

@UntilDestroy()
@Component({
    selector: 'rcp-oup-aging-worklist-summary',
    templateUrl: './aging-worklist-summary.component.html',
    styleUrls: ['./aging-worklist-summary.component.scss'],
    standalone: false,
})
export class AgingWorklistSummaryComponent implements OnInit {
    worklistSummary: WorklistSummaryResponse;
    isLoading: boolean = false;

    constructor(
        private service: ClaimService,
        private alertsService: NotificationServiceUP,
    ) {}

    ngOnInit(): void {
        this.lookup();
    }

    lookup() {
        this.isLoading = true;
        let request: WorklistModuleRequest = {
            module: WorklistModuleRequest.ModuleEnum.Aging,
        };
        this.service
            .getWorklistSummary(request)
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (result) => {
                    this.isLoading = false;
                    this.worklistSummary = result;
                },
                error: (error) => {
                    this.isLoading = false;
                    this.alertsService.showError(
                        'Error loading Worklist Summary.',
                        error.error,
                    );
                    console.error(error);
                },
            });
    }
}
